import React, { useState } from 'react'
import PropTypes from 'prop-types'

export const InfoPopover = ({ royalties, commissions }) => {
  const [show, setShow] = useState(false)

  return (
    <span
      className="d-inline-flex align-items-center ml-1"
      style={{ position: 'relative', cursor: 'default' }}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      <i className="fa-regular fa-info-circle" style={{ fontSize: '13px', color: '#9ca3af' }} />
      {show && (
        <span
          className="text-white rounded"
          style={{
            position: 'absolute',
            bottom: 'calc(100% + 8px)',
            left: '50%',
            transform: 'translateX(-50%)',
            background: '#1f2937',
            fontSize: '11.5px',
            lineHeight: '1.5',
            padding: '8px 12px',
            whiteSpace: 'nowrap',
            zIndex: 20,
            pointerEvents: 'none',
          }}
        >
          <span className="d-flex justify-content-between" style={{ gap: '10px' }}>
            <span style={{ color: '#9ca3af' }}>Royalties</span>
            <span style={{ fontWeight: 600, color: royalties ? '#4ade80' : '#6b7280' }}>
              {royalties ? 'Yes' : 'No'}
            </span>
          </span>
          <span className="d-flex justify-content-between mt-1" style={{ gap: '10px' }}>
            <span style={{ color: '#9ca3af' }}>Commissions</span>
            <span style={{ fontWeight: 600, color: commissions ? '#4ade80' : '#6b7280' }}>
              {commissions ? 'Yes' : 'No'}
            </span>
          </span>
        </span>
      )}
    </span>
  )
}

InfoPopover.propTypes = {
  royalties: PropTypes.bool.isRequired,
  commissions: PropTypes.bool.isRequired,
}
